/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,   } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import { WalletService }  from '../../../services/wallet.services';
import { ItemBean } from '../../../beansts/item.bean';
import { SpacialBean } from '../../../beansts/spacial.bean';
import { TranslationService } from '../../../services/translation.service';
import { Door } from '../../../beansts/itens/door.bean';
import { NotificationBean } from '../../../beansts';

declare var $ : any;
declare var Swal: any
declare let solanaWeb3:any
@Component({
    selector : 'memory-container-modal',
    templateUrl:'memory-container-modal.html',
    providers  : [],
})
export class MemoryContainerModal implements OnInit {
  public list;
  public containerList;
  public itemGroupList;
  public container=null;
  public ground=false;
  public groundList;
  public groundName='Chão';
  public containerImg='/assets/game-ui/bag/bag.png'

  public nfts;
  public pubKey=null
  public connection;

  public tell=false;
  public paint;
  public equipChanged={};
  public containerName='Container';
  public title='Clique para usar'

  public ctx;
  public canvas;

  public recipe;

  public mode=1;
  public voidImage
  public MAXQUANTITY=10;
  public gender='male';
  public skin ='rgb(255, 0, 0,.2)';
  public shirt='rgb(255, 0, 0,.6)';
  public pants='rgb(0, 0, 255,.2)';
  public head='rgb(0, 0, 0,1)'
  public shoes='rgb(0, 0, 0,1)';
  public bodyTypeUrl
  public headTypeUrl
  public chestTypeUrl
  public legsTypeUrl
  public feetTypeUrl
  public bufferImage;
  public bufferName;
  public avatar;
  public admin=true;
  public allLoaded=false;
  public wallet

    public ngOnInit() : any {
      this.list = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
   
    }


    public change() {

      this.mode=1;
      this.list = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
      this.sendIframeMessage({kind:'getPosition',params:''},'gameFrame')
      //checkout if i have a usercontainer and garantee all is ok with images

      if (this._appData.object.itens){
        let i=0
        let lid=0;
        this._appData.object.itens.forEach(element => {        
                  this.list[lid]=element;
                  lid++;
        });
      }
      this.ground=false;
      this.container=this._appData.object.objectId;
    }
    constructor( public _appData : AppDataService,public translate: TranslationService,public _companyService : CompanyService,public _walletService : WalletService,public _auth : UserService) {
    }



    public sendIframeMessage(messageKind,frame){
      var iframe = document.getElementById(frame);
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }
   

    public clickContainerItem(item){
       //take item out of inventory to the container
      this._companyService.removeFromContainer(this.container,item).then(val=>{
          this.containerList=this.containerList.filter((it)=>{
            return (item.objectId!=it.objectId)
          })
      })
      this._companyService.addToUserContainer(this._appData.instagramUser,item.toDB()).then(val=>{
          this.list.unshift(item)
          this._appData.userEventContainer=this.list;
      })

    }

    public clickItem(item){

      this._appData.object=item
      
            let date=new Date();
            let milis=date.getTime()
            Swal.fire({
              title: this.translate.instant('CONTAINER_MODAL_23'),
              icon: "warning",
              showConfirmButton: false,
              showCloseButton: true,
              html: `
                <p>O que você deseja fazer?</p>
                <div>
                  <button id="itemUseClick`+milis+`" class="btn btn-primary" >Utilizar</button>
                  <button id="itemShareClick`+milis+`" class="btn btn-danger" >Compartilhar</button>
                  <button id="itemGroundClick`+milis+`" class="btn btn-secondary" >Pro chão</button>
                </div>`
            });
            $(document).on('click', '#itemUseClick'+milis, ()=> {
              Swal.close();
              if (!item.masterpiece){
                this.useItem(item);
              }
              else{
                this._walletService.getProperties(item).subscribe(val=>{
                  let vdata=val.json();
                  item.properties=vdata.properties;
                  this.useItem(item);
                })

              }

            });
            $(document).on('click', '#itemShareClick'+milis, ()=> {
              Swal.close();
              if (item.action=="room"){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_24')})
                return;
              }
              let date=new Date();
              let time=date.getTime();
              let name=this._appData.instagramUser.full_name;
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:name,
                senderThumbnail:'',
                subject:this.translate.instant('CONTAINER_MODAL_25'),
                message:name+this.translate.instant('CONTAINER_MODAL_26'),
                kind:'seeLink',
                link:item.param.link,
                read:false,
                action:'',
                answer:''
              }

              if (this._appData.page=='meeting'){
                this._companyService.addRoomNotification(this._appData.room,notification)
              }
              else{
                if (this._appData.localConference){
                  this._appData.localConference.forEach(element => {
                    if (element.uid==this._appData.instagramUser.uid){
                      Swal.fire({
                        title:this.translate.instant('CONTAINER_MODAL_27'),
                        text:this.translate.instant('CONTAINER_MODAL_28'),
                        confirmButtonText: this.translate.instant('YES'),
                        cancelButtonText:this.translate.instant('NO'),
                        showCancelButton: true,
                        showCloseButton: true,
                      }).then((result) => {
                        if (result.value) {
                          //abrir celular no espaco
                          this._companyService.openExternalLink(notification.link,false)

                        }
                      })
                    }
                    else{
                      this._companyService.sendNotificationToSomeoneElse(this._appData.event,this._appData.instagramUser,element,notification.subject,notification.message,'seeLink',notification.link,false)
                    }
                  });
                }
                else{
                  this.sendIframeMessage({"kind":"shareItemToUsers","item":item},'gameFrame')
                }
              }
            });
            $(document).on('click', '#itemGroundClick'+milis, ()=> {
              Swal.close();
              if (item.equiped){
                Swal.fire({title:this.translate.instant('CONTAINER_MODAL_15'),text:this.translate.instant('CONTAINER_MODAL_29')})
              }
              else if (item.undroppable){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_30')})
              }
              else if (this._appData.room.id.indexOf('noroom')>=0){
                Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_31')})
              }
              else{
                this.removeItem(item);
              }
            });

          
        
    }
    public calculateItemPosition(item){
      let myx=this._appData.instagramUser.position.x
      let myy=this._appData.instagramUser.position.y
      let idx=0;
      if (this._appData.room.backgroundPhoto){
        this._appData.room.backgroundPhoto.forEach(photo=>{
          if  ( (myx> (photo.x-photo.ra)) && (myx < (photo.x+photo.ra)) && (myy < (photo.y+photo.ra)) && (myy> (photo.y-photo.ra)) ){
            item.space=idx
            item.position={x:0,y:0,z:0}
            item.position.x=photo.x;
            item.position.y=photo.y;
            item.position.z=0;
          }
          idx++;
        })
      }
      else{
        item.position={x:0,y:0,z:0}
        if (this._appData.instagramUser.position.x){
          if ((this._appData.instagramUser.position.x-this._appData.room.defaultPlace.x)>500){
            item.position.x=this._appData.room.defaultPlace.x
            item.position.y=this._appData.room.defaultPlace.y
            item.position.z=0 
          }
          else{
            item.position.x=this._appData.instagramUser.position.x
            item.position.y=this._appData.instagramUser.position.y
            item.position.z=0   
          }
        }
        else{
          item.position.x=this._appData.room.defaultPlace.x
          item.position.y=this._appData.room.defaultPlace.y
          item.position.z=0
        }

      }
      return item;
    }
    public removeItem(item){

      //ask position
      this.sendIframeMessage({"kind":"getPosition"},'gameFrame')
      Swal.fire({title:this.translate.instant('CONTAINER_MODAL_32'),
          text:this.translate.instant('CONTAINER_MODAL_33'),
          confirmButtonText: this.translate.instant('YES'),
          cancelButtonText:this.translate.instant('NO'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
                  item.owner=this._appData.instagramUser.uid;
                  item=this.calculateItemPosition(item);
                  if (!item.masterpiece){
                    //put item on room database
                    item.room=this._appData.room.id;
                    item.location='ground';
                    this._companyService.getUserRoomItemRef(this._appData.room.id).doc(item.objectId.toString()).set(item).then( v=>{
                      //update item on inventory so that it looks unavailable
                      this.list=this.list.filter(v=>{
                        return v.objectId!=item.objectId;
                      })
                      this.sendIframeMessage({kind:'removeContainerMemoryItem',container:this.container,item:item.objectId},'gameFrame')
                    })
                  }
                  else{
                    Swal.fire({title:this.translate.instant('FAIL'),text:this.translate.instant('CONTAINER_MODAL_34')})
                  }



            }
      })
    }
    public reload(idx){
      if (idx==2){
        this.mode=2;
        let item=this._appData.object;
        this.itemGroupList = new Array(25).fill({'name':this.translate.instant('CONTAINER_MODAL_14'),thumbnail:'/assets/avatars/black.png',quantity:0})
        let lastIndex=0
        this._companyService.getUserContainerRef().where('tokenId','==',item.tokenId).get().then(v=>{
          v.forEach(itD=>{
            let it=itD.data();
            if (!it.equipped && it.location!='ground'){
              let item=new ItemBean();
              item.parse(it);
              this.itemGroupList[lastIndex]=item;
              lastIndex=lastIndex+1;
            }
          })
        })
      }
    }
    public useItem(item){


      switch (item.action){
        case "link":{
          this._companyService.openExternalLink(item.param.link,true);
          break
        }
        case "terrain":{
          let room='';
          if (item.param){
            room=item.param.room
          }
          if (item.properties){
            room=item.properties.room;
          }
          if (this._appData.room.id==room){
            this._appData.object=item;
            $('#containerModal').modal("hide");
            $('#editRoomModal').modal("show");
            $('#editRoomModalClick').click();
          }
          else{
            let domain=window.location.origin
            window.location.href=domain+"/gameevent/"+item.properties.map+'?room='+room;
          }
          break;

        }
        case "key":{
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_35'),
          text:this.translate.instant('CONTAINER_MODAL_36')+ item.param.room+this.translate.instant('CONTAINER_MODAL_39'),
          confirmButtonText: this.translate.instant('CONTAINER_MODAL_23'),
          cancelButtonText:this.translate.instant('CONTAINER_MODAL_37'),
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){
              Swal.fire({title:this.translate.instant('CONTAINER_MODAL_38'),
              input: 'text',
              inputAttributes: {
                autocapitalize: 'off'
              },
              showCancelButton: true,
              confirmButtonText: this.translate.instant('SAVE'),
              showLoaderOnConfirm: true,
              preConfirm: (name) => {
                if (name){
                  item.name=name;
                  this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB())
                  for (let i=0;i<this._appData.userEventContainer.length;i++){
                    if (this._appData.userEventContainer[i].objectId==item.objectId){
                      this._appData.userEventContainer[i]=item
                    }
                  }
                }
              }
              })
            }
            else{
              let key=this._appData.room.id;
              if (this._appData.room.meeting){
                key=this._appData.room.father
              }
              if (item.param.room==key){
                this.closeModal();
                this._appData.object=item;
                $(`#roomMediaControlModal`).modal('show')
                $('#mediaControlChange').click();
              }
              else{
                Swal.fire({title:this.translate.instant('CONTAINER_MODAL_40'),text:this.translate.instant('CONTAINER_MODAL_41')})
              }
            }
        });
          break;
        }
        case "room":{
          if (this._appData.room.id==item.param.value){
            this.closeModal();
            $(`#roomMediaControlModal`).modal('show')
            $('#mediaControlChange').click();
          }
          else{
            Swal.fire({title:this.translate.instant('CONTAINER_MODAL_40'),text:this.translate.instant('CONTAINER_MODAL_41')})
          }
          break
        }
        case "openLink":{//open new page
          this._companyService.openExternalLink(item.param.link,true);
          break
        }
        case "game":{
          let param=item.param;
          let gameActions= param.gameActions;
          gameActions.forEach(a=>{
            if (a.kind=='moveItem'){
              let object=a.objectId;
              let position=a.position
              let rotation=a.rotation;
              this._companyService.getUserRoomItemRef(this._appData.room.id).doc(object).update({"position":position,"rotation":rotation})

            }
            if (a.kind=='notification'){
              let link=a.link;
              let recipient=a.recipient;
              let notificationKind=a.notificationKind
              let date=new Date();
              let time=date.getTime();
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:this._appData.instagramUser.full_name,
                senderThumbnail:'',
                subject:recipient,
                message:'',
                kind:notificationKind,
                link:link,
                read:false,
                action:'',
                answer:''
              }
              this._companyService.addRoomNotification(this._appData.room,notification);
            }
          })
0



          break
        }
        case "avatarChange":{//open inside game
/*          this.sendIframeMessage({
            kind:'avatarChange',
            params:item.param,
          },'gameFrame');*/
          let date=new Date();
          let time=date.getTime();
          let notification={
            subject:this._appData.instagramUser.uid,
            avatar:item.param.avatar,
            kind:'updateUserAvatar',
            room:this._appData.room.id,
            date:time
          }
          this._companyService.addEventNotification(this._appData.event,notification)
          break
        }
        case "insideGame":{//open inside game
          this._appData.param={link:item.param.link,name:item.name}
          $('#containerModal').modal('hide')
          $('#externalLinkModal').modal('show')
          $('#externalLinkModalClick').click();
          break
        }
        case "embed":{//embending on the stream
          if (!item.param) item.param={link:''}
          let link=item.param.link;
          this._appData.param={link:link,name:item.name}

          if (!link){
            this.makeEmbedProcess(item,link)
          }
          else{
            Swal.fire({title:this.translate.instant('CONTAINER_MODAL_42'),
                      text:this.translate.instant('CONTAINER_MODAL_43'),
                      confirmButtonText:this.translate.instant('CONTAINER_MODAL_44'),
                      cancelButtonText:this.translate.instant('CONTAINER_MODAL_45'),
                      showCloseButton: true,
                      showCancelButton: true,
                      focusConfirm: false,
                      }).then((result) => {
                        if (result.dismiss=='backdrop') {}
                        else if (result.dismiss=='close') {}
                        else if (result.dismiss=='cancel'){
                          this.makeEmbedProcess(item,link)
                        }
                        else{
                            $('#containerModal').modal('hide')
                            this._companyService.openExternalLink(item.param.link,true);
                        }
                    });
          }
          break
        }
        case "modal":{
          $('#containerModal').modal('hide')
          $('#'+item.src).modal("show")
          break;
        }
        case "equip":{
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_46'),text:this.translate.instant('CONTAINER_MODAL_47'),showCloseButton: true,
            confirmButtonText: this.translate.instant('YES'),
            cancelButtomText:this.translate.instant('NO'),
            showCancelButton: true,
            }).then((result) => {
            if (result.value) {
              
            }

          })
        break;
        }
        case "door":{
          let door=new Door();
          door.bagUseItem();
          break;
        }

        case "cellphone":{
          this._appData.toggleCellPhone=true;
          $('#containerModal').modal('hide')
          break;
        }
      }
    }
    public makeEmbedProcess(item,link){
      Swal.fire({title:this.translate.instant('CONTAINER_MODAL_50'),
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant('SAVE'),
      showLoaderOnConfirm: true,
      preConfirm: (name) => {
        if (name){
          Swal.fire({title:this.translate.instant('CONTAINER_MODAL_51'),
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Salvar',
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            if (!login){
              Swal.fire(this.translate.instant('FAIL'),this.translate.instant('CONTAINER_MODAL_52'))
            }
            else{
                  item.param.link=login
                  if (login.indexOf('http')<0){
                    login='https://www.'+login;
                  }
                  item.param.name=name;
                  item.name=name;
                  this._companyService.getUserContainerRef().doc(item.objectId).set(item.toDB())
                  for (let i=0;i<this._appData.userEventContainer.length;i++){
                    if (this._appData.userEventContainer[i].objectId==item.objectId){
                      this._appData.userEventContainer[i]=item
                    }
                  }
                    this.list=this._appData.userEventContainer;
                    this._appData.param={link:login,name:item.name}
                    $('#containerModal').modal('hide')
                    let mheight = window.screen.availHeight;
                    let mwidth = window.screen.availWidth;
                    let width=mwidth*60/100;
                    let height=mheight*60/100;
                    let top=mheight*0.1
                    let left=mwidth*0.1
                    window.open(login,
                    'targetWindow',
                    'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width='+width+',height='+height+',top='+top+',left='+left                    );
            }

          }
        });


        }
      }
    })
    }
    public itemToMap(itemToRemove:ItemBean,position){
      			/*ITEM FORMAT:
					id - unique por item kind
					kind - link, sittable, etc
					name
					quantity
					src (parametro pra clique)"https://io2.convertiez.com.br/m/superpaguemenos/shop/products/images/32268/medium/ovo-pascoa-lacta-560g-favn22_78585.jpg"
					thumbnail
			*/
			/* DECORATION FORMAT
			  action, collision, dimensions, link, location, objectId,position,room,texture
			*/
			//preciso guardar isso na sala.
      itemToRemove.position.x=position.x;
      itemToRemove.position.y=position.y;
      itemToRemove.position.z=0;
      itemToRemove.collision=false;
      if (itemToRemove.action=='sittable') {
        itemToRemove['orientation']=0
      }
      return itemToRemove;
    }
    public useMode(){
      this.title=this.translate.instant('CONTAINER_MODAL_53')
      this.ground=false;
      this.groundList=[]
    }
    public discartMode(){
      this.title=this.translate.instant('CONTAINER_MODAL_54')
      this.ground=true;
      this.groundList=[]
      this.groundName=this.translate.instant('CONTAINER_MODAL_55')
      let position=this._appData.instagramUser.position;

    }
    public closeModal(){
      $('#containerModal').modal('hide')

    }
    public testLink(link){
      if (link.indexOf('<iframe')>=0){
        let sidx=link.indexOf('src=')
        link=link.substring(sidx+5)
        let eidx=link.indexOf('"')
        link=link.substring(0,eidx)
        return link;
      }
      else{
        return link;
      }
    }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/container/memory-container-modal.ts